import { Button, CircularProgress, Tooltip, Typography } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useAtomValue } from "jotai";
import { backgroundColorState, userState } from "@/lib/store";
import { UPGRADE_LOCATIONS } from "@/lib/tracking";
import useUpgradeCta from "src/hooks/useUpgradeCta";
import styles from "./SmallObfuscationBanner.module.scss";

/**
 * The padlock over a locked panel, with the way in written on it: "Unlock for $7.99" (the
 * first-month offer, in the viewer's currency) for a visitor or a free account, "Get Advanced"
 * for Basic. The lock used to be the only thing to click and said nothing about the price.
 */
const SmallObfuscationBanner = () => {
    const backgroundColor = useAtomValue(backgroundColorState);
    const user = useAtomValue(userState);
    const { label, caption, loading, onClick } = useUpgradeCta(UPGRADE_LOCATIONS.SMALL_OBFUSCATION_BANNER);

    const noSubscribedUser = user.subscription_plan === "ORTEX Visitor" || user.subscription_plan === "ORTEX Free";

    return (
        <div className={styles.smallObfuscationBanner}>
            <div className={styles.lockIconOverlay} style={{ backgroundColor, opacity: 0.95 }}>
                <Tooltip title={noSubscribedUser ? "Subscribe to view this data" : "Upgrade to view this data"} placement="top" arrow>
                    {loading ? <CircularProgress size={28} sx={{ color: "grey", opacity: 0.7 }} /> : <LockIcon sx={{ fontSize: 28, color: "grey", opacity: 0.7, cursor: "pointer" }} onClick={(e) => onClick(e)} />}
                </Tooltip>
                {/* Dark ink on the teal: white on #30a49f is 2.87:1, this is 6.37:1 (WCAG AA wants 4.5:1 at 13px). */}
                <Button variant="contained" size="small" disabled={loading} onClick={(e) => onClick(e)} className={styles.unlockButton} sx={{ color: "#06100f", textTransform: "none", whiteSpace: "nowrap" }}>
                    {label}
                </Button>
                {caption && (
                    <Typography variant="caption" className={styles.caption}>
                        {caption}
                    </Typography>
                )}
            </div>
        </div>
    );
};

export default SmallObfuscationBanner;
